var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['base-sample-component' ].concat( _vm.styles)},[_c('p',[_vm._v(" I'm a sample base component with inherited style from base.css ")]),(_vm.label)?_c('p',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }